package com.appsyde.shared.modules.account.domain.model

data class CustomerPortalSession(
    val url: String
)
